/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Typography from '@common_typography';
import Show from '@common_show';
// import Divider from '@common_divider';
import Share from '@common_share';
import Button from '@common_button';
import GeneratePrice from '@core_modules/product/pages/default/components/GeneratePrice';
import Dialog from '@common_dialog';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';
import ProductRelated from '@core_modules/product/pages/default/components/ProductRelated';
import ProductUpsell from '@core_modules/product/pages/default/components/ProductUpsell';
import dynamic from 'next/dynamic';
import cx from 'classnames';
import { HeartIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import Skeleton from '@common_skeleton';
import StockStatus from '@common_statusstock';
import ProductLabelDesc from '@core_modules/product/plugins/ProductLabelDesc';
import Image from 'next/image';

import Link from 'next/link';
import { BREAKPOINTS } from '@theme_vars';
import FossilIcon from '@core_modules/theme/plugins/fossilicon';
import ModalProductCompare from '@core_modules/catalog/components/ModalProductCompare';
import ModalStoreList from '@core_modules/product/plugins/ModalStoreList';
import MapPinIcon from '@heroicons/react/24/outline/MapPinIcon';
import ChevronRightIcon from '@heroicons/react/24/outline/ChevronRightIcon';
import VoucherListModal from '@core_modules/product/plugins/VoucherList';
import RewardCaption from '@core_modules/amrewards/plugins/caption';
import FlashSale from '@common/FlashSale';

const ImageSlider = dynamic(() => import('@common_imageslider'), { ssr: true });
const RatingStar = dynamic(() => import('@common_ratingstar'), { ssr: false });
const CustomizableOption = dynamic(() => import('@plugin_customizableitem'));
const OptionItem = dynamic(() => import('@plugin_optionitem'), { ssr: false });
const ReviewList = dynamic(() => import('@core_modules/product/pages/default/components/ReviewList'), { ssr: false });

const WidgetComponent = dynamic(() => import('@core_modules/cms/components/widget/core'), { ssr: true });

const ProductDetailAction = ({
    t,
    slug,
    data,
    isLogin,
    banner,
    reviewValue,
    storeConfig,
    enablePopupImage,
    handleOpenImageDetail,
    isAwGiftCard,
    price,
    priceData,
    loadPrice,
    errorPrice,
    additionalPrice,
    spesificProduct,
    setSpesificProduct,
    dataPrice,
    checkCustomizableOptionsValue,
    customizableOptions,
    setCustomizableOptions,
    errorCustomizableOptions,
    handleWishlist,
    handleSetCompareList,
    expandData,
    openImageDetail,
    enableProductCompare,
    enableWishlist,
    useReviewList,
    useProductTabs,
    useProductImagePreview,
    useShareProduct,
    useProductRelated,
    useProductUpsell,
    setStockStatus,
    setAdditionalPrice,
    setBanner,
    showShortDesc,
    setShowShortDesc,
    reviewRef,
    isMobile,
    classContainer,
    classContentWrapper,
    imageSliderProps = {},
    classImageSliderWrapper,
    handleOption,
    setPrice,
    currencyCode,
    currencyCache,
    openOption,
    setOpenOption,
    enableMultiSeller,
    useStickyImageSlider = false,
    stickyImageSliderTopPosition,
    cmsBankCredit,
    loadingCmsBankCredit,
    isInstock,
    longProductDesc,
    isPdp,
    openDialogProductCompare,
    setOpenDialogProductCompare,
    dataInstallmentPrice,
    loadingInstallmentPrice,
    openModalStoreList,
    handleCloseModalStoreList,
    handleOpenModalStoreList,
    formatted_oms_stores,
    pickupStoresOMSLoading,
    openVoucherList,
    handleCloseVoucherList,
    handleOpenVoucherList,
    handleCopyVoucherCode,
    copied,
    textToCopy,
    handleToggleDesc,
    showFullDesc,
    dataCouponList,
    loadingCouponList,
    openModalProductLabelDesc,
    handleOpenModalProductLabelDesc,
    handleCloseModalProductLabelDesc,
    generateStyle,
    selectedLabelIndex,
    product,
    widgetContentTop,
    widgetContentAside,
    loadingWidget,
    amRewardEnabled = false,
    showReward = false,
    showLinkRegistration = false,
    dataStock = '',
    stockStatus = '',
    dataBrands = {},
}) => (
    <>
        <Show when={enableProductCompare}>
            <ModalProductCompare
                t={t}
                open={openDialogProductCompare}
                setOpen={(isOpen) => setOpenDialogProductCompare(isOpen)}
            />
        </Show>

        <div className="plugin-product-detail-action">
            <Show when={isPdp && !loadingWidget}>
                <div className="cms-block-banner-promo-pdp leading-[0px] desktop:px-[0px] tablet:px-[0px] mobile:px-[16px]">
                    <WidgetComponent
                        data={widgetContentTop}
                        storeConfig={storeConfig}
                        classNameSkeleton="min-h-12 tablet:!min-h-16 mb-4"
                    />
                </div>
            </Show>
            <div
                className={cx(
                    'product-detail-container',
                    'desktop:flex desktop:grid-cols-2',
                    'tablet:mt-[15px] mobile:mt-0',
                    classContainer,
                )}
            >
                <div className={cx('product-detail-slider desktop:w-3/5 desktop:pr-[35px]', 'relative')}>
                    <div
                        className={cx(classImageSliderWrapper)}
                        style={{
                            position: (useStickyImageSlider && stickyImageSliderTopPosition) ? 'sticky' : 'static',
                            top: (useStickyImageSlider && stickyImageSliderTopPosition) ? `${stickyImageSliderTopPosition}px` : 'unset',
                        }}
                    >
                        <ImageSlider
                            useZoom={false}
                            data={banner}
                            storeConfig={storeConfig}
                            onClickZoomImage={useProductImagePreview && enablePopupImage ? handleOpenImageDetail : null}
                            {...imageSliderProps}
                            usedInPdp
                            loop
                        />
                    </div>
                </div>
                <div
                    className={cx(
                        'product-detail-info',
                        'desktop:ml-[0px]',
                        'desktop:px-[0px] tablet:px-[0px] mobile:px-[16px]',
                        'desktop:flex tablet:flex desktop:flex-col tablet:flex-col',
                        'items-start desktop:w-2/5',
                        classContentWrapper,
                    )}
                >
                    <Show when={enableMultiSeller && data?.seller && data?.seller?.seller_name}>
                        <Link href={`/seller/${data?.seller?.seller_path}`}>
                            <Typography
                                variant="bd-2"
                                className={cx(
                                    'line-clamp-1 capitalize',
                                    'leading-5',
                                )}
                                color="text-primary"
                            >
                                {data?.seller?.seller_name || ''}
                            </Typography>
                        </Link>
                    </Show>
                    <Typography
                        variant="h1"
                        className={cx(
                            'swift-page-title first-letter:uppercase mb-[12px] desktop:mt-[0px] tablet:mt-[0px] mobile:mt-[5px]',
                            '!text-neutral-black !text-2xl !tracking-normal !leading-normal !font-semibold',
                        )}
                    >
                        {data?.name || ''}
                    </Typography>
                    {
                        isPdp && (
                            <Show when={product?.items[0]?.amasty_product_labels?.length > 0 && isPdp}>
                                {
                                    product?.items[0]?.amasty_product_labels?.map((itemLabel, indexLabel) => (
                                        // eslint-disable-next-line no-nested-ternary
                                        !itemLabel?.image_pdp && itemLabel?.label_text_pdp !== '' ? (
                                            <div className="label-product relative mb-[10px]" key={indexLabel}>
                                                <div
                                                    className={cx(
                                                        `inner-${indexLabel} py-[3px] px-[7px]`,
                                                        'relative z-10 leading-normal font-semibold text-[12px] tracking-normal cursor-pointer',
                                                    )}
                                                    style={{
                                                        backgroundColor: itemLabel?.background_color_pdp,
                                                        ...generateStyle(itemLabel?.style_pdp),
                                                    }}
                                                    onClick={() => handleOpenModalProductLabelDesc(indexLabel)}
                                                >
                                                    {itemLabel?.label_text_pdp}
                                                </div>
                                            </div>
                                        ) : itemLabel?.image_pdp ? (
                                            <div className="label-image mb-[20px]" key={indexLabel}>
                                                <Image
                                                    src={itemLabel?.image_pdp || ''}
                                                    alt={itemLabel?.label_text_pdp || ''}
                                                    height={itemLabel?.image_size_pdp || '65'}
                                                    width={itemLabel?.image_size_pdp || '65'}
                                                />
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ))
                                }
                                <ProductLabelDesc
                                    t={t}
                                    open={openModalProductLabelDesc}
                                    setOpen={() => handleOpenModalProductLabelDesc(selectedLabelIndex)}
                                    handleClose={handleCloseModalProductLabelDesc}
                                    storeConfig={storeConfig}
                                    label={product?.items[0]?.amasty_product_labels[selectedLabelIndex]?.label_text_pdp}
                                    identifier={product?.items[0]?.amasty_product_labels[selectedLabelIndex]?.popup_block_pdp}
                                />
                            </Show>
                        )
                    }
                    <div className={cx('sku-stock mb-[12px]')}>
                        <div className="flex">
                            <Typography variant="p" className="sku pr-[10px] !text-neutral-550 font-normal">{data?.sku}</Typography>
                            <div className="stock-status">
                                <StockStatus inStock={isInstock} loading={loadPrice} />
                            </div>
                        </div>
                        <Show when={!loadPrice && dataStock?.only_x_left_in_stock}>
                            <div>
                                <Typography variant="p" className="!text-[13px] !text-primary font-normal leading-[1.4]">
                                    {t('product:stockLeft')}
                                    {' '}
                                    <strong>{dataStock?.only_x_left_in_stock}</strong>
                                </Typography>
                            </div>
                        </Show>
                        <Show when={loadPrice}>
                            <div>
                                <Skeleton width={80} height={20} />
                            </div>
                        </Show>
                    </div>
                    <div className="mb-[12px] w-full">
                        <FlashSale
                            isPdp
                            isActive={product?.items[0]?.is_daily_deal}
                            storeConfig={storeConfig}
                            content={product?.items[0]?.flash_content}
                            classWrapperHeader="justify-around  w-full"
                            classWrapper="py-[8px] bg-[#3D5870]"
                        />
                    </div>
                    <Button
                        variant="plain"
                        className="!p-0 flex items-center"
                        onClick={() => {
                                reviewRef?.current?.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        <div className="flex mb-[20px]">
                            <RatingStar value={reviewValue || 0} />
                            <Typography variant="p-2" className="ml-[15px] !text-neutral-500">
                                {`${data.review.reviews_count || 0} ${t('product:review')}`}
                            </Typography>
                        </div>
                    </Button>
                    <Show when={!isAwGiftCard && !loadPrice}>
                        <div
                            className={cx(
                                'product-detail-info-price-container',
                                isMobile && 'flex justify-between flex-wrap gap-[10px]',
                            )}
                        >
                            <div className="product-detail-info-price-left">
                                <GeneratePrice
                                    additionalPrice={additionalPrice}
                                    spesificProduct={spesificProduct}
                                    errorPrice={errorPrice}
                                    loadPrice={loadPrice}
                                    priceDataItem={priceData}
                                    priceItem={price}
                                />
                            </div>

                            {/* SHARE, WISHLIST, COMPARE MOBILE */}
                            <Show when={isMobile}>
                                <div className={cx('product-detail-info-price-right', 'flex items-center gap-1.5')}>
                                    <Show when={enableWishlist}>
                                        <Button variant="plain" icon={false} iconOnly={false} onClick={handleWishlist} className="!p-0 whitespace-nowrap">
                                            <Typography color="text-neutral-500 hover:text-neutral-400 flex items-center" variant="bd-2a">
                                                <HeartIcon className="h-[20px] w-[20px]" />
                                            </Typography>
                                        </Button>
                                    </Show>
                                    <Show when={enableProductCompare}>
                                        <Button
                                            variant="plain"
                                            icon={false}
                                            iconOnly={false}
                                            onClick={() => handleSetCompareList(data?.id)}
                                            className="!p-0 whitespace-nowrap"
                                        >
                                            <Typography color="text-neutral-500 hover:text-neutral-400 flex items-center" variant="bd-2a">
                                                <ArrowsRightLeftIcon className="h-[20px] w-[20px]" />
                                            </Typography>
                                        </Button>
                                    </Show>
                                    <Share />
                                </div>
                            </Show>
                        </div>
                    </Show>

                    <Show when={amRewardEnabled && showReward}>
                        <div className="relative">
                            <RewardCaption className="mb-0" pageId="0" productId={data?.id} isPDP showLinkRegistration={showLinkRegistration} />
                        </div>
                    </Show>

                    <div className="pdp-installment my-[20px] w-full">
                        {
                            !dataInstallmentPrice && loadingInstallmentPrice ? (
                                <>
                                    <Skeleton width="100%" height={20} className="mt-[5px]" />
                                    <Skeleton width="100%" height={20} className="mt-[5px]" />
                                    <Skeleton width="100%" height={20} className="mt-[5px]" />
                                </>
                            ) : (
                                dataInstallmentPrice?.getPriceInstallment.list.map((item, index) => (
                                    <Typography variant="p-2" className="mb-[7px] !text-neutral-500" key={index}>
                                        {item.label}
                                    </Typography>
                                ))
                            )
                        }
                    </div>
                    <Show when={isPdp && !loadingWidget}>
                        <div className="content-banner-sidebar leading-[0px]">
                            <WidgetComponent data={widgetContentAside} storeConfig={storeConfig} />
                        </div>
                    </Show>
                    <Show when={isPdp}>
                        <div className="engraving flex flex-wrap gap-[5px] items-center">
                            <FossilIcon className="!text-neutral-350 mr-[5px] leading-normal" iconContent='"\e937"' fontSize={20} width={20} height={20} />
                            <div className="need-engraving">
                                <Typography
                                    className={cx(
                                        '!text-[12px] !text-neutral-500',
                                    )}
                                >
                                    {t('product:needEngraving')}
                                </Typography>
                            </div>
                            <div className="link">
                                <Link href="/store-locator?engraving=1" className="group/engraving-link">
                                    <Typography
                                        className={cx(
                                            '!text-[12px] !text-neutral-400 group-hover/engraving-link:!text-neutral-800',
                                            'underline !font-medium transition-colors',
                                        )}
                                    >
                                        {t('product:findStore')}
                                    </Typography>
                                </Link>
                            </div>
                        </div>
                    </Show>
                    <CustomizableOption showCustomizableOption={false} />
                    <div className={cx(
                        'flex flex-col gap-4 w-[100%]',
                    )}
                    >
                        <OptionItem
                            price={price}
                            t={t}
                            url_key={data?.url_key || ''}
                            dataPrice={dataPrice}
                            priceData={priceData}
                            setStockStatus={setStockStatus}
                            setAdditionalPrice={setAdditionalPrice}
                            customizableOptions={customizableOptions}
                            setCustomizableOptions={setCustomizableOptions}
                            errorCustomizableOptions={errorCustomizableOptions}
                            checkCustomizableOptionsValue={checkCustomizableOptionsValue}
                            additionalPrice={additionalPrice}
                            handleSelecteProduct={setSpesificProduct}
                            showAddToCart
                            labelAddToCart={t('common:button:addToCart')}
                            setBanner={setBanner}
                            showWishlist={false}
                            enableProductCompare={false}
                            showStockStatus
                            stockStatus={stockStatus || ''}
                            storeConfig={storeConfig}
                            handleOption={handleOption}
                            setPrice={setPrice}
                            currencyCode={currencyCode}
                            currencyCache={currencyCache}
                            openOption={openOption}
                            setOpenOption={setOpenOption}
                            data={{
                                ...data,
                                url_key: slug,
                                review: data?.review,
                            }}
                            dataBrands={dataBrands}
                        />
                    </div>
                    <Show when={data?.short_description?.html?.length > 0 && isPdp}>
                        <div className="product-detail-description-container">
                            <div className="product-detail-description relative">
                                <div
                                    className={cx(
                                        'mt-[24px]',
                                        showShortDesc && 'h-auto',
                                        !showShortDesc && 'desktop:h-[120px] tablet:h-[80px] mobile:h-[80px] overflow-hidden',
                                        'text-base',
                                        'font-normal',
                                        'leading-2lg',
                                        'tracking-normal',
                                    )}
                                >
                                    {data?.short_description?.html ? <CmsRenderer content={data?.short_description?.html} /> : null}
                                </div>
                                <Show when={!showShortDesc && data?.short_description?.html?.length > 0}>
                                    <div
                                        className="w-[100%] h-[25px] absolute bottom-[0px]"
                                        style={{
                                            background:
                                                    'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7497373949579832) 43%, rgba(255,255,255,0) 100%)',
                                        }}
                                    />
                                </Show>
                            </div>
                            <Show when={data?.short_description?.html?.length > 0}>
                                <Button variant="plain" onClick={() => setShowShortDesc(!showShortDesc)} className="!p-0 mt-[6px]">
                                    <Typography variant="bd-2a">
                                        {showShortDesc ? `- ${t('common:label:showLess')}` : `+ ${t('common:label:showMore')}`}
                                    </Typography>
                                </Button>
                            </Show>
                        </div>
                    </Show>
                    <div className="my-[10px]" />
                    <div
                        className={cx(
                            'product-detail-info-footer-container',
                            'desktop:block tablet:block mobile:hidden',
                            'w-[100%]',
                        )}
                    >
                        {/* WISHLIST & COMPARE DESKTOP, TABLET */}
                        <div
                            className={cx(
                                'swift-product-detail-info-footer-action',
                                'flex tablet:justify-start gap-[20px]',
                                'desktop:mt-[0px] tablet:mt-[16px]',
                            )}
                        >
                            <Show when={enableWishlist}>
                                <Button variant="plain" icon={false} iconOnly={false} onClick={handleWishlist} className="!p-0 whitespace-nowrap swift-action-towishlist">
                                    <Typography color="hover:underline !text-neutral-700 flex items-center !text-[12px]" variant="bd-2a">
                                        <HeartIcon className="h-[18px] w-[18px] mr-[6px] !text-neutral-350" />
                                        {t('common:label:addToWishlist')}
                                    </Typography>
                                </Button>
                            </Show>
                            <Show when={enableProductCompare}>
                                <Button
                                    variant="plain"
                                    icon={false}
                                    iconOnly={false}
                                    onClick={() => handleSetCompareList(data?.id)}
                                    className="!p-0 whitespace-nowrap swift-action-tocompare"
                                >
                                    <Typography color="hover:underline !text-neutral-700 flex items-center !text-[12px]" variant="bd-2a">
                                        <ArrowsRightLeftIcon className="h-[18px] w-[18px] mr-[6px] !text-neutral-350" />
                                        {t('common:label:addToCompare')}
                                    </Typography>
                                </Button>
                            </Show>
                            <Show when={useShareProduct}>
                                <div className={cx('swift-product-detail-info-footer-share')}>
                                    <Share classWrapper="leading-[0] mr-[10px]" />
                                </div>
                            </Show>
                        </div>
                        <Show when={isPdp}>
                            <Button
                                align="left"
                                variant="plain"
                                className={cx(
                                    'hover:bg-neutral-75 w-[100%] flex items-center !text-neutral-700 mt-[20px]',
                                    'border-neutral-300 border rounded-md !py-2 !px-3 relative',
                                )}
                                onClick={() => handleOpenModalStoreList()}
                            >
                                <MapPinIcon width={24} height={24} className="h-[24px] w-[24px] !text-neutral-700" />
                                <span className="pl-[15px] pr-[20px] block">
                                    <Typography
                                        className={cx(
                                            'capitalize !leading-tight !text-neutral-700 !text-[13px]',
                                            '!font-semibold block text-left',
                                        )}
                                    >
                                        {t('product:storeList:trigger')}
                                    </Typography>
                                    <Typography
                                        className={cx(
                                            '!leading-normal !text-neutral-700 !text-[10px]',
                                            '!font-normal block text-left',
                                        )}
                                    >
                                        {t('product:storeList:near')}
                                    </Typography>
                                </span>
                                <ChevronRightIcon
                                    width={20}
                                    height={20}
                                    className={cx(
                                        'absolute right-[10px] top-[50%] translate-y-[-50%] h-[20px] w-[20px]',
                                    )}
                                />
                            </Button>
                            <ModalStoreList
                                t={t}
                                open={openModalStoreList}
                                setOpen={() => handleOpenModalStoreList()}
                                listStores={formatted_oms_stores}
                                handleClose={handleCloseModalStoreList}
                                isPdp
                                storeConfig={storeConfig}
                                withLoading={pickupStoresOMSLoading}
                            />

                        </Show>
                        <Show when={isPdp}>
                            {
                                dataCouponList?.getAvailableCouponList?.length > 0 && (
                                    <div className="voucher-list">
                                        <Button
                                            className={cx(
                                                'w-full min-h-[38px] [&.button-link]:justify-center uppercase',
                                                'my-[20px] bg-primary hover:bg-secondary-600',
                                            )}
                                            classNameText="justify-center xs:flex-wrap sm:flex-nowrap"
                                            variant="secondary"
                                            onClick={handleOpenVoucherList}
                                        >
                                            <Typography className="!text-neutral-white uppercase !font-bold !text-[13px] !leading-normal !tracking-wide">
                                                {t('product:voucherPdp:buttonTrigger')}
                                            </Typography>
                                        </Button>
                                    </div>
                                )
                            }
                        </Show>
                    </div>
                    <Show when={isMobile && isPdp}>
                        <Button
                            align="left"
                            variant="plain"
                            className={cx(
                                'hover:bg-neutral-75 w-[100%] flex items-center !text-neutral-700 mt-[20px]',
                                'border-neutral-300 border rounded-md !py-2 !px-3 relative mb-[20px]',
                            )}
                            onClick={() => handleOpenModalStoreList()}
                        >
                            <MapPinIcon width={24} height={24} className="h-[24px] w-[24px] !text-neutral-700" />
                            <span className="pl-[15px] pr-[20px] block">
                                <Typography
                                    className={cx(
                                        'capitalize !leading-tight !text-neutral-700 !text-[13px]',
                                        '!font-semibold block text-left',
                                    )}
                                >
                                    {t('product:storeList:trigger')}
                                </Typography>
                                <Typography
                                    className={cx(
                                        '!leading-normal !text-neutral-700 !text-[10px]',
                                        '!font-normal block text-left',
                                    )}
                                >
                                    {t('product:storeList:near')}
                                </Typography>
                            </span>
                            <ChevronRightIcon
                                width={20}
                                height={20}
                                className={cx(
                                    'absolute right-[10px] top-[50%] translate-y-[-50%] h-[20px] w-[20px]',
                                )}
                            />
                        </Button>
                        <ModalStoreList
                            t={t}
                            open={openModalStoreList}
                            setOpen={() => handleOpenModalStoreList()}
                            listStores={formatted_oms_stores}
                            handleClose={handleCloseModalStoreList}
                            isPdp
                            storeConfig={storeConfig}
                            withLoading={pickupStoresOMSLoading}
                        />
                        {
                            dataCouponList?.getAvailableCouponList?.length > 0 && (
                                <div className="voucher-list">
                                    <Button
                                        className={cx(
                                            'w-full min-h-[38px] [&.button-link]:justify-center uppercase',
                                            'mb-[20px] bg-primary hover:bg-secondary-600',
                                        )}
                                        classNameText="justify-center xs:flex-wrap sm:flex-nowrap"
                                        variant="secondary"
                                        onClick={handleOpenVoucherList}
                                    >
                                        <Typography className="!text-neutral-white uppercase !font-bold !text-[13px] !leading-normal !tracking-wide">
                                            {t('product:voucherPdp:buttonTrigger')}
                                        </Typography>
                                    </Button>
                                </div>
                            )
                        }
                    </Show>
                    <Show when={isPdp}>
                        <VoucherListModal
                            t={t}
                            openVoucherList={openVoucherList}
                            handleCloseVoucherList={handleCloseVoucherList}
                            dataCouponList={dataCouponList}
                            loadingCouponList={loadingCouponList}
                            copied={copied}
                            textToCopy={textToCopy}
                            handleCopyVoucherCode={handleCopyVoucherCode}
                            showFullDesc={showFullDesc}
                            handleToggleDesc={handleToggleDesc}
                            isPdp
                        />
                    </Show>
                </div>
            </div>
            <Show when={useProductTabs}>
                <div className={cx(
                    'wrapper-swift-product-detail-tabs',
                    'desktop:my-[64px] tablet:my-[64px] mobile:my-[50px]',
                    'desktop:grid tablet:grid desktop:grid-cols-2 tablet:grid-cols-2',
                )}
                >
                    <div className={cx(
                        'left-desc desktop:bg-neutral-50 tablet:bg-neutral-50',
                        'desktop:flex tablet:flex desktop:justify-end tablet:justify-end relative',
                        'mobile:mb-[30px]',
                    )}
                    >
                        <div className={cx(
                            'inner',
                            'desktop:px-[10px] tablet:px-[16px] mobile:px-[16px]',
                            'desktop:!pr-[50px] desktop:py-[50px] tablet:py-[25px]',
                            'max-w-full relative z-[2]',
                        )}
                        >
                            {
                                longProductDesc && (
                                    <>
                                        <Typography
                                            variant="h3"
                                            className={cx(
                                                '!text-2xl !font-semibold !text-neutral-black desktop:mb-[20px] mobile:mb-[10px] !leading-normal',
                                            )}
                                        >
                                            {t('product:description')}
                                        </Typography>
                                        <CmsRenderer content={longProductDesc} storeConfig={storeConfig} />
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className={cx(
                        'right-detail',
                        'desktop:flex tablet:flex desktop:justify-start tablet:justify-start',
                    )}
                    >
                        <div className={cx(
                            'inner',
                            'desktop:px-[10px] tablet:px-[16px] mobile:px-[16px]',
                            'desktop:!pl-[50px] desktop:py-[50px] tablet:py-[25px]',
                            'max-w-full',
                        )}
                        >
                            <Typography
                                variant="h3"
                                className={cx(
                                    '!text-2xl !font-semibold !text-neutral-black desktop:mb-[20px]  mobile:mb-[10px] !leading-normal',
                                )}
                            >
                                {t('product:specification')}
                            </Typography>
                            { expandData && (
                                expandData.map((item, index) => {
                                    if (item.type === 'react-component') {
                                        return (
                                            <div
                                                className={cx('item-spec')}
                                                key={index}
                                            >
                                                {item.content ? item.content : null}
                                            </div>
                                        );
                                    }
                                    return null;
                                })
                            )}
                            {
                                cmsBankCredit && (
                                    !cmsBankCredit && loadingCmsBankCredit ? (
                                        <>
                                            <Skeleton width="100%" height={40} className="mt-[40px]" />
                                            <Skeleton width="100%" height={20} className="mt-[10px]" />
                                            <Skeleton width="100%" height={20} className="mt-[5px]" />
                                            <Skeleton width="100%" height={20} className="mt-[5px]" />
                                        </>
                                    ) : (
                                        <div className="cms-bank-credit-info mt-[30px]">
                                            <CmsRenderer content={cmsBankCredit} storeConfig={storeConfig} />
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            </Show>

            <Show when={useReviewList}>
                <div ref={reviewRef} className={cx('swift-product-list-review-container', 'mt-[48px]', 'desktop:px-[0px] tablet:px-[16px] mobile:px-[16px]')}>
                    <ReviewList t={t} data={data} storeConfig={storeConfig} isLogin={isLogin} dataBrands={dataBrands} />
                </div>
            </Show>

            <Show when={useProductImagePreview && enablePopupImage}>
                <Dialog
                    useCloseButton
                    open={openImageDetail}
                    variant="plain"
                    classWrapper="!bg-opacity-100 bg-neutral-white"
                    onClickClose={handleOpenImageDetail}
                    closeOnBackdrop
                    onClose={handleOpenImageDetail}
                >
                    <ImageSlider horizontalThumbnail openImageDetail detectAutoScreen={false} data={banner} storeConfig={storeConfig} loop />
                </Dialog>
            </Show>
            <Show when={useProductUpsell}>
                <ProductUpsell
                    t={t}
                    dataProduct={data}
                    isLogin={isLogin}
                    storeConfig={storeConfig}
                    carouselProps={{
                        className: 'mobile:!-ml-1 mobile:!-mr-1 tablet:!-ml-6 tablet:!-mr-6',
                        classNameItem: 'mobile:first:!ml-4 tablet:first:!ml-6',
                    }}
                />
            </Show>
            <Show when={isPdp}>
                <div className="py-10" />
            </Show>
            <Show when={useProductRelated}>
                <ProductRelated
                    t={t}
                    dataProduct={data}
                    isLogin={isLogin}
                    storeConfig={storeConfig}
                    carouselProps={{
                        className: '',
                        classNameItem: '',
                    }}
                />
            </Show>
        </div>
        <style jsx>
            {`
                .wrapper-swift-product-detail-tabs {
                    width: 100vw;
                    position: relative;
                    margin-left: -50vw;
                    left: 50%;
                }
                @media(max-width: ${BREAKPOINTS.md}px) {
                    .wrapper-swift-product-detail-tabs .left-desc:after,
                    .wrapper-swift-product-detail-tabs .left-desc:before {
                        display: none;
                    }
                }
                .wrapper-swift-product-detail-tabs .left-desc .inner,
                .wrapper-swift-product-detail-tabs .right-detail .inner {
                    width: calc(${BREAKPOINTS.xlpdp}px / 2);
                }
            `}
        </style>
    </>
);

export default ProductDetailAction;
